module.exports = __webpack_public_path__ + "59947d0a0e06ee4c47829d3b04debfb4.svg";